import { useTranslation } from "react-i18next";
import { useLangFont } from "../../../hooks/useLangFont";

const infoRowDefs = [
  { labelKey: "ci_company",     value: "World Link株式会社",                              link: null },
  { labelKey: "ci_rep",         value: "馬超",                                            link: null },
  { labelKey: "ci_license",     value: "第62125R073197号",                                link: null },
  { labelKey: "ci_address",     value: "〒541-0056　大阪府大阪市中央区瓦町1-2-12",       link: null },
  { labelKey: "ci_hours",       value: "ci_hours_val",                                    link: null },
  { labelKey: "ci_area",        value: "ci_area_val",                                     link: null },
  { labelKey: "ci_brands",      value: "HERMÈS / CHANEL / LOUIS VUITTON / GUCCI / PRADA 他", link: null },
  { labelKey: "ci_email_label", value: "zoshinjp@worldlink.jp",                           link: "mailto:zoshinjp@worldlink.jp" },
];

const translatableValues = new Set(["ci_hours_val", "ci_area_val"]);

export default function CompanyInfo() {
  const { t } = useTranslation();
  const { heading, body } = useLangFont();

  return (
    <section className="py-20 bg-[#0F1924] w-full">
      <div className="max-w-5xl mx-auto px-6">
        <div className="mb-12">
          <span
            className="text-[#C9A84C] text-xs font-bold tracking-[0.3em] uppercase"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Company Profile
          </span>
          <h2
            className="text-3xl font-bold text-white mt-2 mb-1 tracking-tight"
            style={{ fontFamily: heading }}
          >
            {t("company_title")}
          </h2>
          <div className="w-12 h-0.5 bg-[#C9A84C] mt-3" />
        </div>

        <div className="border border-white/8 rounded-2xl overflow-hidden">
          {infoRowDefs.map((row, i) => {
            const displayValue = translatableValues.has(row.value) ? t(row.value) : row.value;
            return (
              <div
                key={row.labelKey}
                className={`flex flex-col sm:flex-row ${i < infoRowDefs.length - 1 ? "border-b border-white/8" : ""}`}
              >
                <div
                  className="sm:w-48 flex-shrink-0 px-6 py-5 flex items-center"
                  style={{ background: "rgba(201,168,76,0.06)" }}
                >
                  <span
                    className="text-[#C9A84C] text-xs font-semibold tracking-widest"
                    style={{ fontFamily: body }}
                  >
                    {t(row.labelKey)}
                  </span>
                </div>
                <div className="hidden sm:block w-px bg-white/8 flex-shrink-0" />
                <div className="flex-1 px-6 py-5 flex items-center">
                  {row.link ? (
                    <a
                      href={row.link}
                      className="text-white/80 text-sm hover:text-[#C9A84C] transition-colors duration-200 underline underline-offset-4 decoration-white/20 hover:decoration-[#C9A84C]"
                      style={{ fontFamily: body, fontWeight: 300 }}
                    >
                      {displayValue}
                    </a>
                  ) : (
                    <span
                      className="text-white/80 text-sm"
                      style={{ fontFamily: body, fontWeight: 300 }}
                    >
                      {displayValue}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
